import { Button } from "@/components/ui/button";
import Icons from "@/components/Icons";
import { Loader2Icon } from "lucide-react";
import type { MouseEventHandler } from "react";
import React from "react";
import type { ThemeConfig } from "@/lib/theme-utils";

interface PayPalButtonProps {
  isLoading?: boolean;
  isDisabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  theme?: ThemeConfig;
}

const PayPalButton = React.forwardRef<HTMLDivElement, PayPalButtonProps>(
  ({ isLoading = false, isDisabled = false, onClick, theme }, ref) => {
    const borderRadius = theme?.buttonRadius || '6px';
    
    return (
      <div className="flex flex-col gap-[10px]" ref={ref}>
        {isLoading ? (
          <Button 
            variant="disabled" 
            disabled
            className="h-[48px]"
            theme={theme}
          >
            <Loader2Icon className="animate-spin" />
            Please wait
          </Button>
        ) : (
          <Button
            type={onClick ? "button" : "submit"}
            disabled={isDisabled}
            onClick={onClick}
            className="h-[48px] flex items-center justify-center gap-2"
            style={{
              borderRadius,
              background: '#283593',
              color: 'white'
            }}
          >
            <span className="text-left text-[17px]">Pay With</span>
            <Icons type="paypal" size={32} />
          </Button>
        )}
      </div>
    );
  }
);

PayPalButton.displayName = "PayPalButton";

export default PayPalButton;
